import { Produktlinie, VermietetesObjektQuoteDB } from '@ps20-frontend/frontend-models';
import {
  Dialogschritt,
  FahrzeugArt,
  FahrzeugeVersichert,
  Selbstbeteiligung,
  TaasRequestModel,
  TaasSparte,
  Tarifbereich,
  Zahlungsart,
  Zahlweise,
} from '@ps20/bff-models';
import { QuoteDbVorteilrabattItem } from './quoteDbVorteilrabattItem';

export interface TarifierungsVektorQuoteDB<T> {
  selectedProduktlinie: Produktlinie;
  treuebonus_aktuell: number;
  treuebonus_max: number;
  rdbMax: number;
  rbdSparte: number;
  laufZeitSparte: number;
  zahlweise: Zahlweise;
  selbstbeteiligung: Selbstbeteiligung;
  zahlungsArt: Zahlungsart;
  kombinachlass: number;
  fahrzeugeVersichert?: FahrzeugeVersichert;
  fahrzeugeArt?: FahrzeugArt;
  vermieterBausteine?: Array<VermietetesObjektQuoteDB>;
  dialogschritt?: Dialogschritt;
  alleProduktlinien?: Array<Produktlinie>;
  taasSparteRequestModel: TaasRequestModel<T>;
  tarifbereich: Tarifbereich;
  vorteilsrabatt: QuoteDbVorteilrabattItem;
  beibehaltung: boolean;
  vorteilsrabattActive: boolean;
}

export function addVorbelegteVorschaedenToTaasRequestModel<T extends TaasSparte<unknown>>(
  taasRequestModel: TaasRequestModel<T>,
  vorvertragVorschaeden: number | null,
  vorschadenAttributName: keyof T | null,
): TaasRequestModel<T> {
  if (vorvertragVorschaeden != null) {
    return {
      ...taasRequestModel,
      taasSparte: {
        ...taasRequestModel.taasSparte,
        [vorschadenAttributName]: vorvertragVorschaeden,
      },
    };
  }

  return taasRequestModel;
}
